import React from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';
import { CommonDropDownStyle } from '../../ui/styled';

const FormInputDropdown = (props) => {
  const {
    name,
    control,
    label,
    options,
    defaultValue,
    isTrue,
    yesNoDropDown,
    errors,
    helperText,
    cbpContact,
    cbpProgram,
    disabled,
    register,
    modalityList,
    modalityListProvider,
    provider,
    authTypeList,
    budgetTypeList,
    isDate,
    organizations,
    getIdValue,
    yesNoIdDropDown,
    isWeeks,
    shrink,
    verifyDischarge
  } = props;

  const generateSingleOptions = () => {
    //if (verifyDischarge) {
    //  options.unshift({id: null, value: '<Clear Entry>'})
    //}
    return options?.map((item, index) => {
      return (
        <MenuItem
          key={index}
          value={
            isTrue
              ? item.key
              : cbpProgram
              ? item.orgKey
              : cbpContact
              ? item.cntKey
              : modalityList
              ? item.modDsc
              : authTypeList
              ? item.athTypId
              : budgetTypeList
              ? item.budTypeId
              : organizations
              ? item.orgId
              : getIdValue
              ? item.id
              : yesNoIdDropDown
              ? item.yesNoId
              : isDate
              ? item.id
              : isWeeks
              ? item.value.split('T')[0]
              : item.value
          }                  
        >
          {isTrue
            ? item.key
            : isDate
            ? item.id
            : isWeeks
            ? item.value.split('T')[0]
            : item.value}
          {yesNoDropDown && item.booleanText}
          {cbpProgram && item.orgKey}
          {cbpContact && item.cntKey}
          {modalityList && item.modDsc + ' | ' + item.modId}
          {modalityListProvider && ' | ' + item.id}
          {provider && ' | ' + item.id}
          {authTypeList && item.athTypId}
          {budgetTypeList && item.budTypeId}
          {organizations && item.orgKey}
          {yesNoIdDropDown && item.booleanIdText}
        </MenuItem>
      );
    });
  };

  return (
    <CommonDropDownStyle>
      <InputLabel shrink={shrink}>{label}</InputLabel>
      <Controller
        register={register}
        render={({ field: { onChange, onBlur, value } }) => (
          <Select
            defaultValue={defaultValue}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            error={errors}
            disabled={disabled}
          >
            {generateSingleOptions()}
          </Select>
        )}
        control={control}
        name={name}
      />
      <FormHelperText style={{ color: '#ff4d4f' }}>{helperText}</FormHelperText>
    </CommonDropDownStyle>
  );
};

export default FormInputDropdown;
